module.exports = __webpack_public_path__ + "static/img/科技馆.a71e2330.png";